import React from 'react';
import PropTypes from 'prop-types';

const CheckOptionView = (props) => {

    return <div className="aside-options">
        <div className={`clearfix ${props.containerClasses}`}>
            {props.title && <small><b>{props.title}</b></small>}

            <label className={`switch switch-text switch-pill switch-sm float-right switch-${props.switchClass}`}>

                <input type="checkbox" className="switch-input" disabled={props.disabled} checked={props.value}  onChange={(evt) => {

                    const value = evt.target.checked;
                    if(props.onChange){
                        props.onChange(value);
                    }

                }} />

                <span className="switch-label" data-on={props.onText} data-off={props.offText}></span>
                <span className="switch-handle"></span>
            </label>
        </div>
        {props.hint && <div>
            <small className="text-muted">{props.hint}</small>
        </div>}
    </div>

};

CheckOptionView.propTypes = {
    title: PropTypes.string,
    hint: PropTypes.string,
    onChange: PropTypes.func,
    onText: PropTypes.string,
    offText: PropTypes.string,
    switchClass: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    containerClasses: PropTypes.string
};

CheckOptionView.defaultProps = {
    onText : "On",
    offText: "Off",
    switchClass: "success",
    containerClasses: "mt-4"
};

export default CheckOptionView;


// WEBPACK FOOTER //
// ./src/common/CheckOptionView/CheckOptionView.js